var l = typeof global == "object" && global && global.Object === Object && global;
const e = l;
export {
  e as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/lodash-es@4.17.21/~/lodash-es/_freeGlobal.js
// module id = 914
// module chunks = 67